module.exports = __webpack_public_path__ + "assets/img/bg0.8d9b89be.gif";